import React from "react";

import EmptyState from "@adsk/alloy-react-empty-state";
import { useTranslations } from "@adsk/acc-issues-translations";

const IssuesEmptyState = () => {
  const { T } = useTranslations();
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
      title={T.translate("referencePickerPlugin.noIssues")}
      description={T.translate("referencePickerPlugin.noIssuesDescription")}
    />
  );
};

export default IssuesEmptyState;
